/**
 * Behavioural archetypes — display metadata for the tags derived from each decision
 * card's "Leadership Angle".
 *
 * These are DERIVED, never authored: the trainer writes prose ("Classic defensive
 * conflict") and the importer maps it to tags. They drive debrief reporting and colour
 * only, and never affect scoring — so a mislabelled tag costs a wrong chip, not a wrong
 * number.
 *
 * Kept here rather than in the reference fixture because they are product vocabulary
 * that every simulation shares, not data belonging to one example.
 */
export const BEHAVIOUR_TAGS = {
  collaborative: { label: 'Collaborative', variant: 'emerald' },
  systemic:      { label: 'Systems thinking', variant: 'teal' },
  transparent:   { label: 'Transparent', variant: 'blue' },
  assertive:     { label: 'Assertive', variant: 'indigo' },
  controlling:   { label: 'Controlling', variant: 'violet' },
  compromising:  { label: 'Compromising', variant: 'slate' },
  shortTermist:  { label: 'Short-term', variant: 'amber' },
  avoidant:      { label: 'Avoidant', variant: 'amber' },
  defensive:     { label: 'Defensive', variant: 'rose' },
  blameShifting: { label: 'Blame-shifting', variant: 'red' },
};

export default BEHAVIOUR_TAGS;
